<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      @if (srDetailLoader) {
        <app-skeleton-loader
          [formLoader]="true"
          [noOfFields]="5"
        ></app-skeleton-loader>
      }
      @if (!srDetailLoader) {
        <form [formGroup]="form">
          <!--  Membership selector  -->
          @if (step == 1) {
            <section>
              <h1 class="section-heading">
                {{ "INFO_SERVICE.SELECT_MEMBERSHIP_TITLE" | translate }}
              </h1>
              <div class="fields-container">
                <div class="field-control">
                  <app-active-memberships
                    [memberships]="memberships"
                    [membershipId]="membershipId"
                    (selectMembership)="setSelectedMemberShip($event)"
                  ></app-active-memberships>
                  @if (!membershipId && selectMembershipError) {
                    <app-validation-message
                      [type]="'error'"
                      [content]="{
                        title: 'VALIDATION_MSG.ERROR' | translate,
                        message: 'VALIDATION_MSG.SELECT_MEMBERSHIP' | translate,
                      }"
                      [showbutton]="false"
                    ></app-validation-message>
                  }
                </div>
                @if (step == 1) {
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                    <app-button
                      classesName="btn-edge-cut btn-primary-big"
                      [label]="'BUTTONS.CONTINUE' | translate"
                      (onBtnClick)="proceedToNext()"
                    ></app-button>
                  </div>
                }
                <!-- message box -->
                @if (step == 1) {
                  <div class="field-control">
                    <app-validation-message
                      type="default"
                      [content]="{
                        title: 'INFO_SERVICE.COMPANY_NOT_LISTED' | translate,
                        message:
                          'INFO_SERVICE.COMPANY_NOT_LISTED_DESC' | translate,
                      }"
                      [showbutton]="false"
                      [buttonText]="
                        'INFO_SERVICE.REQUEST_AUTHORISATION' | translate
                      "
                      (onBtnClick)="gotoAddBusiness()"
                    />
                  </div>
                }
              </div>
            </section>
          }

          <!-- Information service details -->
          @if (step >= 2) {
            <!-- Action for show notes -->
            @if (srNumber && srInprgoressAwating && !srDetailLoader) {
              <app-validation-message
                type="info"
                [content]="{
                  title: 'SECTION_NOTES' | translate,
                  message: 'SECTION_NOTES_DESCRIPTION' | translate,
                }"
                [showbutton]="false"
                [buttonText]="'VIEW_NOTES' | translate"
                (onBtnClick)="showNotes = true"
              />
            }

            <section>
              <h1 class="section-heading">
                {{ "INFO_SERVICE.SECTION_INFORMATION_TITLE" | translate }}
              </h1>
              <div class="fields-container">
                <div class="field-control">
                  <app-option-field
                    [label]="'INFO_SERVICE.ENQUIRY_TYPE' | translate"
                    [options]="enquiryTypes"
                    [control]="form.get('enquiryType')!"
                    (onSelectionChange)="getLetterTypes($event)"
                    [labelKey]="'Value'"
                    [valueKey]="'Value'"
                  ></app-option-field>
                </div>
                <div class="field-control">
                  <app-option-field
                    [label]="'INFO_SERVICE.LETTER_TYPE' | translate"
                    [options]="letterTypes"
                    [control]="form.get('letterType')!"
                    [labelKey]="
                      lang == 'en' ? 'Description' : 'Product Name ARA'
                    "
                    [valueKey]="'Name'"
                    (onSelectionChange)="onLetterTypeChange($event)"
                  ></app-option-field>
                </div>

                <!-- SR List of free marketing -->
                @if (!this.parentSrId) {
                  <app-information-request-list
                    [form]="form"
                    [accountServiceRequests]="accountServiceRequests"
                    [accountServiceRequestsLoading]="
                      accountServiceRequestsLoading
                    "
                    (selectionChange)="onAccountServiceRequestSelected($event)"
                  ></app-information-request-list>

                  @if (showSelectSrToAmendmentError) {
                    <div class="field-control">
                      <app-validation-message
                        type="error"
                        [content]="{
                          title: 'Error' | translate,
                          message:
                            'INFO_SERVICE.SELECT_SR_TO_AMENDMENT' | translate,
                        }"
                      ></app-validation-message>
                    </div>
                  }
                } @else {
                  <div class="field-control">
                    <label class="field-label">{{
                      "INFO_SERVICE.AMENDMENT_SR_NUMBER" | translate
                    }}</label>
                    <input
                      type="text"
                      class="w-full border border-dc-navy px-3 py-2 text-dc-navy bg-gray-100"
                      [value]="selectedAccountServiceRequest?.['SR Number']"
                      disabled
                      readonly
                    />
                  </div>
                  @if (showActions) {
                    <div class="field-control">
                      <app-button
                        classesName="card-edge-cut-white btn-width-auto"
                        [label]="'BUTTONS.CHANGE' | translate"
                        (onBtnClick)="changeSelectedAccountServiceRequest()"
                      ></app-button>
                    </div>
                  }
                }

                @if (
                  form.get("letterType")?.value ==
                    fieldValue.INFORMATION_LETTER_TYPE_COO_BY_DC ||
                  form.get("letterType")?.value ==
                    fieldValue.INFORMATION_LETTER_TYPE_COO_BY_DC_AR
                ) {
                  <div class="field-control">
                    <app-text-field
                      [label]="'INFO_SERVICE.COO_OPTIONAL' | translate"
                      [control]="form.get('cooNumber')!"
                      [maxlength]="50"
                      (blur)="getListOfCOO()"
                    ></app-text-field>
                  </div>
                  @if (showCooNumberError) {
                    <app-validation-message
                      [content]="{
                        title: 'ALERT.NO_RESULTS_TITLE' | translate,
                        message: 'ALERT.CORRECT_COO_NUMBER' | translate,
                      }"
                      type="error"
                    />
                  }
                }
                @if (
                  form.get("enquiryType")?.value ==
                    fieldValue.COMPANY_PROFILE ||
                  form.get("enquiryType")?.value ==
                    fieldValue.COMPANY_PROFILE_AR
                ) {
                  <div class="field-control">
                    <app-option-field
                      [label]="'INFO_SERVICE.SELECT_MEMBER' | translate"
                      [options]="members"
                      [control]="form.get('companyMember')!"
                      (search)="handleSearch($event)"
                      [loading]="loadingMember"
                      [showMemberFilter]="true"
                      (onSelectionChange)="updateMemberNuber($event)"
                    ></app-option-field>
                  </div>
                }
                @if (
                  form.get("letterType")?.value ==
                    fieldValue.LOCATION_OUTSIDE_FREEZONE && enablePhaseTwoChange
                ) {
                  <div class="field-control">
                    <!-- <app-text-field
                      [type]="'big-text'"
                      [label]="'INFO_SERVICE.ADDRESS' | translate"
                      [control]="form.get('address')!"
                      [maxlength]="100"
                      (blur)="getListOfCOO()"
                    ></app-text-field> -->
                     <app-option-field
                      [label]="'INFO_SERVICE.ADDRESS' | translate"
                      [control]="form.get('address')!"
                      [lovType]="lookupKey.AREA_CODES"
                    ></app-option-field>
                  </div>
                }

                @if (fieldVisible) {
                  <app-option-field
                    [label]="
                      'INFO_SERVICE.SELECT_CERTIFICATE_LANGUAGE' | translate
                    "
                    [lovType]="lookupKey.COO_DC_LANG"
                    [control]="form.get('certificateLang')!"
                    [labelKey]="'Value'"
                    [valueKey]="'Value'"
                  ></app-option-field>
                }
              </div>
            </section>

            <!-- Form 1 and 2 fields -->
            @if (isFreeMarketing && enablePhaseTwoChange && fieldVisible) {
              <section>
                <h1 class="section-heading">
                  {{ "INFO_SERVICE.FREE_MARKETING_DETAIL" | translate }}
                </h1>

                <div class="fields-container">
                  <div class="field-control">
                    <app-boolean
                      [label]="'INFO_SERVICE.SELECT_MARKETING_FORM' | translate"
                      [control]="form.get('certificateForm')!"
                      [options]="marketingForms"
                      [labelKey]="'label'"
                      [valueKey]="'value'"
                      (onSelectionChange)="(false)"
                    />
                  </div>

                  @if (form.get("certificateForm")?.value) {
                    <!-- Exporter Name -->
                    <div class="field-control">
                      <app-text-field
                        [type]="'big-text'"
                        [otherInfo]="'INFO_SERVICE.BUYER_PH' | translate"
                        [label]="'INFO_SERVICE.BUYER' | translate"
                        [control]="form.get('buyer')!"
                        [maxlength]="150"
                      ></app-text-field>
                    </div>

                    <!-- Exporter Address -->
                    <div class="field-control">
                      <app-text-field
                        [label]="'INFO_SERVICE.INVOICE_NUMBER' | translate"
                        [control]="form.get('invoiceNumber')!"
                        [maxlength]="250"
                      ></app-text-field>
                    </div>
                    <div class="field-control">
                      <app-date
                        [label]="'INFO_SERVICE.INVOICE_DATE' | translate"
                        [control]="form.get('invoiceDate')!"
                        [allowedDate]="'past'"
                        [noOfPastMonth]="6"
                      ></app-date>
                    </div>
                    @if (
                      form.get("certificateForm")?.value == "Certificate-2"
                    ) {
                      <div class="field-control">
                        <app-option-field
                          [country]="true"
                          [label]="'INFO_SERVICE.EXPORTER_COUNTRY' | translate"
                          [control]="form.get('exporterCountry')!"
                          [lovType]="lookupKey.COUNTRY"
                          [labelKey]="'Value'"
                          [valueKey]="'Value'"
                          [validationMessages]="{
                            exporterCountryUaeNotAllowed:
                              'ALERT.EXPORTER_COUNTRY_CANNOT_BE_UAE'
                                | translate,
                          }"
                        ></app-option-field>
                      </div>

                      <div class="field-control">
                        <app-text-field
                          [label]="
                            'INFO_SERVICE.CERTIFICATE_OF_ORIGIN_NUMBER'
                              | translate
                          "
                          [control]="form.get('certificateOfOriginNumber')!"
                          [maxlength]="50"
                        ></app-text-field>
                      </div>
                      @if (showCooNumberError) {
                        <app-validation-message
                          [content]="{
                            title: 'ALERT.NO_RESULTS_TITLE' | translate,
                            message: 'ALERT.CORRECT_COO_NUMBER' | translate,
                          }"
                          type="error"
                        />
                      }
                      <app-date
                        [label]="
                          'INFO_SERVICE.CERTIFICATE_OF_ORIGIN_DATE' | translate
                        "
                        [control]="form.get('certificateOfOriginDate')!"
                        [allowedDate]="'past'"
                        [noOfPastMonth]="6"
                      ></app-date>
                    }

                    <!-- Add Products  -->
                    <div class="mt-4">
                      <div class="field-control">
                        <!-- products list -->
                        @if (products.length > 0) {
                          <div class="product-table-wrapper">
                            <div class="md:hidden p-3 border-b border-dc-navy">
                              <div class="product-table-search">
                                <input
                                  type="text"
                                  [placeholder]="'COO.SEARCH_PRODUCT_NAME' | translate"
                                  formControlName="searchProductText"
                                  class="w-full"
                                />
                                <i class="fas fa-search pl-2 cursor-pointer"></i>
                              </div>
                            </div>
                            <table class="product-table">
                              <thead>
                                <tr>
                                  <th class="w-[70%]">
                                    {{ "COO.PRODUCT_NAME" | translate }}
                                  </th>

                                  <th class="w-[20%]">
                                    {{ "COO.PRODUCT_COO" | translate }}
                                  </th>

                                  <th class="w-[10%]">
                                    <div class="product-table-search">
                                      <input
                                        type="text"
                                        [placeholder]="
                                          'COO.SEARCH_PRODUCT_NAME' | translate
                                        "
                                        formControlName="searchProductText"
                                      />
                                      <i
                                        class="fas fa-search pl-2 cursor-pointer"
                                      ></i>
                                    </div>
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                @for (row of paginatedProducts; track $index) {
                                  <tr>
                                    <td [attr.data-label]="'COO.PRODUCT_NAME' | translate">
                                      <span class="font-semibold">{{
                                        row.productHSCode
                                      }}</span>
                                      <span class="block text-gray-600">
                                        {{
                                          lang == "ar"
                                            ? row.kindOfGoods
                                            : row.kindOfGoods
                                        }}
                                      </span>
                                    </td>

                                    <td [attr.data-label]="'COO.PRODUCT_COO' | translate">
                                      {{ row.countryOfOrigin }}
                                    </td>

                                    <td [attr.data-label]="'Actions'">
                                      @if (showActions) {
                                        <div
                                          class="flex items-center justify-start md:justify-center gap-2"
                                        >
                                          <a
                                            class="text-dc-dark-blue font-semibold underline underline-offset-4 mr-4 cursor-pointer"
                                            (click)="editProduct(row)"
                                            >{{ "BUTTONS.EDIT" | translate }}</a
                                          >

                                          <button
                                            class="text-dc-navy font-semibold"
                                            (click)="removeProduct(row)"
                                          >
                                            <i class="fa-solid fa-xmark"></i>
                                          </button>
                                        </div>
                                      }
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </table>

                            <div class="px-2">
                              <app-pagenation
                                [data]="{
                                  currentPage: currentPage,
                                  totalPages: totalPages,
                                  totalItems: filteredProducts.length,
                                }"
                                (pageChangeEvent)="loadPage($event)"
                              ></app-pagenation>
                            </div>
                          </div>
                        }
                        @if (showActions) {
                          <div class="buttons-group mt-5">
                            <div class="flex gap-4">
                              <app-button
                                type="button"
                                classesName="btn-edge-cut btn-primary-small"
                                [label]="'BUTTONS.ADD_PRODUCTS' | translate"
                                (onBtnClick)="openAddProductModal()"
                              ></app-button>
                            </div>
                          </div>

                          @if (
                            form.get("productList")?.touched &&
                            form.get("productList")?.hasError("required")
                          ) {
                            <app-validation-message
                              [type]="'error'"
                              [content]="{
                                title: 'VALIDATION_MSG.ERROR' | translate,
                                message:
                                  'VALIDATION_MSG.ADD_PRODUCT' | translate,
                              }"
                              [showbutton]="false"
                            ></app-validation-message>
                          }
                        }
                      </div>
                    </div>
                  }
                </div>
              </section>
            }
            <!-- Signatory list -->
            @if (
              form.get("letterType")?.value ==
                fieldValue.AUTHORIZED_SIGNATORY_CERTIFICATE ||
              (form.get("letterType")?.value ==
                fieldValue.AUTHORIZED_SIGNATORY_CERTIFICATE_AR &&
                enablePhaseTwoChange)
            ) {
              <div class="fields-container">
                <div class="field-control">
                  <label class="field-label">{{
                    "ATTESTATION.SELECT_SIGNATORY" | translate
                  }}</label>

                  @if (
                    singatoryList &&
                    singatoryList.length > 0 &&
                    enablePhaseTwoChange
                  ) {
                    <div class="fields-error-container">
                      <!-- Show custom error messages -->
                      @if (
                        form.get("signatory")?.errors &&
                        !form.get("signatory")?.value
                      ) {
                        {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
                      }
                    </div>

                    <div class="space-y-2">
                      @for (singatory of singatoryList; track singatory) {
                        <div>
                          <div class="card-edge-cut relative border-blue">
                            <div class="card-body mb-5">
                              <div class="flex gap-5">
                                <input
                                  type="radio"
                                  [value]="
                                    singatory['DC Related Party Name English']
                                  "
                                  formControlName="signatory"
                                  class="h-5 w-5 text-dc-navy border-gray-300 accent-dc-navy mt-1"
                                />
                                <div class="text-dc-navy!">
                                  <span class="font-semibold">
                                    {{
                                      singatory["DC Related Party Name English"]
                                    }}</span
                                  >
                                  <p class="text-dc-navy! py-2">
                                    {{
                                      singatory["DC Related Party Name Arabic"]
                                    }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <!-- If no signatory list  -->
                  @if (
                    !singatoryList ||
                    (singatoryList.length < 1 &&
                      enablePhaseTwoChange &&
                      !loadingSignatory)
                  ) {
                    <div class="field-control">
                      <app-validation-message
                        type="error"
                        [content]="{
                          title: 'ATTESTATION.SIGNATORY_NOT_FOUND' | translate,
                          message:
                            'ATTESTATION.SIGNATORY_NOT_FOUND_MSG' | translate,
                        }"
                      ></app-validation-message>
                    </div>
                  }
                </div>
              </div>
            }
            <!-- End signatory list -->

            <!-- Owner/Partner list -->
            @if (
              form.get("letterType")?.value ==
                fieldValue.LETTER_TYPE_OWNER_PARTNER ||
              (form.get("letterType")?.value ==
                fieldValue.LETTER_TYPE_OWNER_PARTNER &&
                enablePhaseTwoChange)
            ) {
              <div class="fields-container">
                <div class="field-control">
                  <label class="field-label">{{
                    "INFO_SERVICE.SELECT_OWNER_PARTNER" | translate
                  }}</label>

                  <div class="fields-error-container">
                    @if (
                      form.get("owner")?.errors && !form.get("owner")?.value
                    ) {
                      {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
                    }
                  </div>
                  @if (
                    listOfOwnerParters &&
                    listOfOwnerParters.length > 0 &&
                    enablePhaseTwoChange
                  ) {
                    <div class="space-y-2">
                      @for (owner of listOfOwnerParters; track owner) {
                        <div>
                          <div class="card-edge-cut relative border-blue">
                            <div class="card-body mb-5">
                              <div class="flex gap-5">
                                <input
                                  type="radio"
                                  [value]="owner['Row Id']"
                                  formControlName="owner"
                                  class="h-5 w-5 text-dc-navy border-gray-300 accent-dc-navy mt-1"
                                />
                                <div class="text-dc-navy!">
                                  <span class="font-semibold">
                                    {{
                                      owner["Related Party Contact Name Eng"] || owner["DC Name(ENGLISH)"]
                                    }}</span
                                  >
                                  <p class="text-dc-navy! py-2">
                                    {{
                                      owner["Related Party Contact Name Ara"] || owner["DC Name(ARABIC)"]
                                    }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }

                  @if (
                    !listOfOwnerParters ||
                    (listOfOwnerParters.length < 1 && enablePhaseTwoChange && !ownerLoading)
                  ) {
                    <div class="field-control">
                      <app-validation-message
                        type="error"
                        [content]="{
                          title: 'INFO_SERVICE.OWNER_NOT_FOUND' | translate,
                          message:
                            'INFO_SERVICE.OWNER_NOT_FOUND_MSG' | translate,
                        }"
                      ></app-validation-message>
                    </div>
                  }
                </div>
              </div>
            }
          }

          @if (step >= 3 && fieldVisible) {
            @if (
              form.get("enquiryType")?.value != fieldValue.COMPANY_PROFILE &&
              form.get("enquiryType")?.value != fieldValue.COMPANY_PROFILE_AR
            ) {
              <section class="space-y-4">
                <h1 class="section-heading">
                  {{ "DOCUMENTS.TITLE" | translate }}
                </h1>
                <div class="px-2 hidden">
                  <p [innerHTML]="'DOCUMENT_NOTE' | translate"></p>
                </div>
                <div class="fields-container">
                  @if (loadingDoc) {
                    <app-skeleton-loader
                      [formLoader]="true"
                      [noOfFields]="3"
                    ></app-skeleton-loader>
                  }
                  @if (srFolder && !loadingDoc) {
                    @for (dt of visibleDocumentTypes; track $index) {
                      <div class="field-control">
                        <app-file
                          #fileCmp
                          [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                          [control]=""
                          [documentType]="dt.nameEn"
                          (folderMissing)="openFolder()"
                          (onUploadRemove)="handelFileEvent($event, dt.nameEn)"
                          [showAction]="showActions"
                          [folder]="srFolder"
                          [documentServiceType]="
                            documentServiceType.INFORMATION_SERVICE
                          "
                        ></app-file>
                      </div>
                    }
                  }
                </div>
              </section>
            }
          }
          @if (step >= 2 && fieldVisible) {
            <!-- section for payment method -->
            <section>
              <h1 class="section-heading">
                {{ "SECTION_PAYMENT_METHOD" | translate }}
              </h1>
              <div class="fields-container">
                <div class="field-control">
                  <app-boolean
                    [label]="'PAYMENT_METHOD' | translate"
                    [control]="form.get('paymentMethod')!"
                    [lovType]="lookupKey.PAYMENT_METHOD"
                    [labelKey]="'Value'"
                    [valueKey]="'Value'"
                    (onSelectionChange)="onPaymentMethodChange($event)"
                  />
                </div>
                @if (noAdvancePaymentBalance) {
                  <app-validation-message
                    [content]="{
                      title: 'ALERT.ERROR' | translate,
                      message: 'ALERT.NO_ADVANCE_PAYMENT_BALANCE' | translate,
                    }"
                    type="error"
                  />
                }
              </div>
            </section>
          }
          @if (step > 1) {
            <div class="fields-container">
              <div class="field-control py-5">
                <app-checkbox
                  [control]="form.get('detailsConfirmed')"
                  [options]="[
                    { label: 'VERIFY_ACTIVITY' | translate, value: 'Yes' },
                  ]"
                  [disabled]="!showActions"
                />
              </div>
            </div>
          }

          <!-- Error Message -->
          @if (technicalErrorMsg) {
            <app-validation-message
              [type]="'error'"
              [content]="{
                title: 'VALIDATION_MSG.ERROR' | translate,
                message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate,
              }"
              [showbutton]="false"
            ></app-validation-message>
          }

          <!-- Error Message -->
          @if (errorMsg) {
          <app-validation-message
            [type]="'error'"
            [showCloseIcon]="false"
            [content]="{
              title: 'ALERT.ERROR' | translate,
              message: errorMsg
            }"
          >
          </app-validation-message>
          }
          <!-- bottom actions -->
          @if (step >= 2) {
            @if (showActions && !formSubmitLoader) {
              <div class="btn-section buttons-group">
                <app-button
                  classesName="btn-edge-cut btn-width-auto"
                  (onBtnClick)="nextStep()"
                  [label]="'BUTTONS.NEXT' | translate"
                ></app-button>
                @if (showSaveAndCloseAction) {
                  <app-button
                    classesName="card-edge-cut-white btn-width-auto"
                    [label]="'BUTTONS.SAVE_CLOSE' | translate"
                    (onBtnClick)="saveAndClose()"
                  ></app-button>
                }
              </div>
            }
            @if (formSubmitLoader) {
              <app-button
                type="button"
                classesName="btn-edge-cut btn-width-auto"
                [label]="'PLEASE_WAIT' | translate"
                [disabled]="true"
              ></app-button>
            }
          }
        </form>
      }
    </div>
  </div>
</div>
<!-- Form Completion Progress -->
@if (!srDetailLoader) {
  <div>
    <app-service-progress
      [serviceName]="'INFO_SERVICE.LETTER_CERTIFICATES' | translate"
      [completePercentage]="formProgress"
    />
  </div>
}
@if (successModal) {
  <app-sr-submit-success-modal
    [srNumber]="srNumber"
    (onClose)="closeSuccessModal()"
  ></app-sr-submit-success-modal>
}

<!-- notes modal -->
@if (showNotes) {
  <app-notes
    [srNumber]="srNumber"
    [allowSubmit]="true"
    (onClose)="showNotes = false"
  ></app-notes>
}
<!--  -->
@if (openMarketingProductModal) {
  <div class="dc-modal">
    <div class="dc-modal-container">
      <button
        class="modal-x-button"
        type="button"
        (click)="openMarketingProductModal = false"
      >
        <i class="fas fa-close"></i>
      </button>
      <h1 class="section-heading">
        {{ "INFO_SERVICE.FREE_MARKETING_DETAIL" | translate }}
      </h1>
      <app-marketing-product-form
        [(isOpen)]="openMarketingProductModal"
        [selectedProduct]="selectedProduct"
        (onBtnClick)="onProductFormSubmit($event)"
      />
    </div>
  </div>
}
